import { graphql } from 'gql'

export const GET_RICH_PLACEMENT_K_WORDS = graphql(`
  query getRichPlacementKWords($workspaceId: ID!, $canReadKWordsSiteId: Boolean!) {
    workspaceRichPlacementKwordsConfiguration(workspaceId: $workspaceId) {
      id
      kwordsSiteId @include(if: $canReadKWordsSiteId)
    }
  }
`)
